export default __webpack_public_path__ + "static/media/kitchen2-480w.75be828e.png";